<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>{{$t('service.title')}}</h2>
        <div class="irinox-form service-form" >

          <div class="p-grid p-nogutter p-mb-3 dashboard-metrics">
            <div class="p-col-12 p-d-flex p-flex-row p-ai-center p-py-3 p-px-4 dashboard-metric" :class="[$config.maintenanceEnabled() ? 'p-md-6 p-xl-3' : 'p-lg-4']">
              <img src="assets/irinox/icons/dashboard_dealer_total.svg" :alt="$t('service.metrics.total')" />
              <div class="p-d-flex p-flex-column p-jc-center p-pl-3">
                <div class="dashboard-metric-label">{{$t('service.metrics.total')}}</div>
                <div class="dashboard-metric-value">{{ total }}</div>
              </div>
            </div>
            <div class="p-col-12 p-d-flex p-flex-row p-ai-center p-py-3 p-px-4 dashboard-metric" :class="[$config.maintenanceEnabled() ? 'p-md-6 p-xl-3' : 'p-lg-4']">
              <img src="assets/irinox/icons/dashboard_dealer_online.svg" :alt="$t('service.metrics.online')" />
              <div class="p-d-flex p-flex-column p-jc-center p-pl-3" style="width: 100%;">
                <div class="dashboard-metric-label">
                  <span>{{$t('service.metrics.online')}}</span>
                  <span>{{ total > 0 ? $n((online/total)*100, 'integer') : '0' }}%</span>
                </div>
                <div class="dashboard-metric-value">{{ online }}</div>
              </div>
            </div>
            <div v-if="$config.maintenanceEnabled()" class="p-col-12 p-md-6 p-xl-3 p-d-flex p-flex-row p-ai-center p-py-3 p-px-4 dashboard-metric">
              <img src="assets/irinox/icons/dashboard_dealer_maintenance.svg" :alt="$t('service.metrics.maintenance')" />
              <div class="p-d-flex p-flex-column p-jc-center p-pl-3" style="width: 100%;">
                <div class="dashboard-metric-label">
                  <span>{{$t('service.metrics.maintenance')}}</span>
                  <span>{{ total > 0 ? $n((anomalies/total)*100, 'integer') : '0' }}%</span>
                </div>
                <div class="dashboard-metric-value">{{ anomalies }}</div>
              </div>
            </div>
            <div class="p-col-12 p-d-flex p-flex-row p-ai-center p-py-3 p-px-4 dashboard-metric" :class="[$config.maintenanceEnabled() ? 'p-md-6 p-xl-3' : 'p-lg-4']">
              <img src="assets/irinox/icons/dashboard_dealer_alert.svg" :alt="$t('service.metrics.alert')" />
              <div class="p-d-flex p-flex-column p-jc-center p-pl-3" style="width: 100%;">
                <div class="dashboard-metric-label">
                  <span>{{$t('service.metrics.alert')}}</span>
                  <span>{{ total > 0 ? $n((alarms/total)*100, 'integer') : '0' }}%</span>
                </div>
                <div class="dashboard-metric-value">{{ alarms }}</div>
              </div>
            </div>
          </div>

          <div class="p-grid dashboard-overview p-mt-2 p-mb-4">

            <div class="p-col-12 p-lg-6 p-xxl-4 p-d-flex p-ai-stretch">
              <div class="dashboard-report p-p-3">
                <div class="title">{{$t('service.report.title')}}</div>
                <div class="subtitle p-mt-2 p-mb-1">{{$t('service.report.subtitle')}}</div>
                <hr />
                <div v-for="report in reports" :key="'rep_'+report.installationReportId" class="p-grid p-nogutter dashboard-report-row">
                  <div class="p-col">{{$d(new Date(report.updateTimestamp),'shortNumeric')}}</div>
                  <div class="p-col">{{ report.serialNumber }}</div>
                  <div class="p-col">{{ report.company }}</div>
                  <div class="p-col-fixed p-text-right" style="width: 80px;">
                    <span v-if="report.complete" class="dashboard-report-status-complete">{{$t('service.report.completed')}}</span>
                    <span v-else class="dashboard-report-status-draft">{{$t('service.report.draft')}}</span>
                  </div>
                </div>
                <div class="p-d-flex p-jc-end p-mt-3 button-bar">
                  <Button :label="$t('service.report.button_view_all')" class="p-button-outlined" @click="() => { this.$router.push({ name: 'report' }); }" />
                  <Button :label="$t('service.report.button_create_new')" class="" @click="() => { this.$router.push({ name: 'report-new' }); }" />
                </div>
              </div>
            </div>

            <div class="p-col-12 p-lg-6 p-xxl-4 p-d-flex p-ai-stretch">
              <div class="dashboard-docs p-p-3">
                <div class="title">{{$t('service.docs.title')}}</div>

                <div class="p-d-flex p-flex-column p-mt-2" style="gap: 10px">
                  <div v-for="favorite in favoritesEnhanced" :key="'fav_'+favorite" class="p-d-flex p-jc-between p-ai-center favorite-item" style="gap: 10px">
                    <div class="p-d-flex p-ai-center">
                      <img :src="$config.afterSalesAssets('models') + selectedKey(favorite) + '.png'" :alt="'MODEL'" style="width:100px;" :onerror="'if (!this.src.includes(\'.svg\')) this.src=\''+$config.afterSalesAssets('models') + selectedKey(favorite) + '.svg\''" />
                      <span>{{favorite.label}}</span>
                    </div>
                    <div class="">
                      <Button :label="$t('service.docs.button_view_docs')" class="p-button-outlined" @click="() => { this.$router.push({ path: `/after-sales/tree/${favorite.docTreeId}` }); }" />
                    </div>
                  </div>
                </div>


                <div class="p-d-flex p-jc-end p-mt-3 button-bar">
                  <Button :label="$t('service.docs.button_view_favorites')" class="p-button-outlined" @click="() => { this.$router.push({ name: 'after-sales-favorites' }); }" />
                  <Button :label="$t('service.docs.button_view_all')" class="" @click="() => { this.$router.push({ name: 'after-sales' }); }" />
                </div>
              </div>
            </div>

            <div class="p-col-12 p-lg-6 p-xxl-4 p-d-flex p-ai-stretch">
              <div class="dashboard-news p-p-3">
                <div class="title">{{$t('service.news.title')}}</div>

                <div v-if="news!=null" class="p-d-flex p-mt-2" style="gap: 10px;">
                  <div class="dashboard-news-image p-d-flex p-ai-center p-jc-center">
                    <div>
                      <picture>
                        <img :src="news.coverImage[0].webp" :alt="news.title" />
                      </picture>
                    </div>
                  </div>
                  <div class="p-d-flex p-flex-column p-jc-center" style="gap: 10px;">
                    <div class="dashboard-news-title">{{ news.title }}</div>
                    <!-- <div class="dashboard-news-description">{{ news.shortDescription?.substring(0, 100) }}...</div> -->
                    <div class="dashboard-news-description">{{ news.shortDescription }}</div>
                    <div>
                      <Button :label="$t('service.news.button_view_article')" class="p-button-outlined" @click="geToWebsite(news.uri)" />
                    </div>
                  </div>
                </div>


                <div class="p-d-flex p-jc-end p-mt-3 button-bar">
                  <Button :label="$t('service.news.button_view_all')" class="" @click="geToWebsite()" />
                </div>
              </div>
            </div>




          </div>

          <div>
            <h3>{{$t('service.tab_appliances')}}</h3>
            <div class="p-mt-3">
              <Appliances />
            </div>
          </div>
          <!-- <TabView>
            <TabPanel :header="$t('service.tab_appliances')">
              <Appliances/>
            </TabPanel>
          </TabView> -->
        </div>
		</div>
	</div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('service.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

</template>

<script>
import ReportService from '../../service/ReportService';
import WebsiteService from '../../service/WebsiteService';
import AfterSalesService from '../../service/AfterSalesService';
import ApplianceService from '../../service/ApplianceService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import Appliances from './Appliances.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
      Appliances,
      IrinoxDialogDark
    },
    data() {
        return {
          reports: [],
          news: null,
          overview: null,
          dialog: {
            error: false,
          },
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          is24hour: 'userdata/is24hour',
          docTreeRaw: 'afterSales/docTreeRaw',
          favorites: 'afterSales/favorites',
        }),
        total: function() {
          return this.overview?.body?.totalAppliances ?? 0;
        },
        online: function() {
          return this.overview?.body?.connectedAppliances ?? 0;
        },
        anomalies: function() {
          return this.overview?.body?.maintenanceRequiredAppliances ?? 0;
        },
        alarms: function() {
          return this.overview?.body?.activeErrorAppliances ?? 0;
        },
        favoritesEnhanced() {
          let fv = [];
          this.favorites.slice(0,2).forEach(fav => {
            let model = this.selectedModel(fav);
            let label = this.docLabelLeaf(model);
            if(model) {
              fv.push({...model, label: label});
            }
          });
          return fv;
        },
    },
    watch: {
      '$i18n.locale': 'loadNews',
    },
    created() {
      this.reportService = new ReportService();
      this.afterSalesService = new AfterSalesService();
      this.websiteService = new WebsiteService();
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.reloadReports();
      this.loadFavorites();
      this.loadNews();
      this.loadOverview();
    },
    methods: {
      loadOverview() {
        this.applianceService.getAppliancesOverview(this.personaltoken)
          .then((data) => {
            if (data.code == '200') {
              this.overview = data;
            } else {
              this.overview = null;
              console.error('ERROR ' + JSON.stringify(data));
            }
          })
          .catch(error => {
            this.overview = null;
            console.error('ERROR ' + error);
          });
      },
      reloadReports() {
        this.reportService.getListV2(this.personaltoken, {}, { rows: 3, first: 0 })
          .then((data) => {
            if(data.code=='200') {
              // this.reports = data.body.sort((a,b) => this.$functions.compareNumbers(a,b,'updateTimestamp')).slice(0, 3);
              this.reports = data.body.items;
            } else {
              this.reports = [];
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            this.reports = [];
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      },
      loadFavorites() {
        this.afterSalesService.getDocTree(this.personaltoken, this.$functions.language(this.$i18n.locale))
          .then((data) => {
            if (data.code == "200") {
              this.$store.commit('afterSales/docTreeRaw', data.body);
              this.afterSalesService.getFavorites(this.personaltoken)
                .then((data) => {
                  if (data.code == "200") {
                    this.$store.commit('afterSales/favorites', data.body);
                  } else {
                    console.error(JSON.stringify(data));
                    this.$store.commit('afterSales/favorites', []);
                    this.dialog.error = true;
                  }
                })
                .catch(error => {
                  console.error("ERROR " + error);
                  this.$store.commit('afterSales/favorites', []);
                  this.dialog.error = true;
                });
            } else {
              console.error(JSON.stringify(data));
              this.$store.commit('afterSales/docTreeRaw', []);
              this.$store.commit('afterSales/favorites', []);
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR " + error);
            this.$store.commit('afterSales/docTreeRaw', []);
            this.$store.commit('afterSales/favorites', []);
            this.dialog.error = true;
          });
      },
      selectedModel(docTreeId) {
        if(docTreeId) {
          return this.docTreeRaw.find(item => item.docTreeId == docTreeId);
        } else {
          return null;
        }
      },
      docLabelLeaf(m) {
        for(let lev=5; lev>=2; lev--) {
          if(m['level'+lev]) {
            let label = (m['level'+(lev-1)+'Translation'] ?? m['level'+(lev-1)]) + ' - ' + (m['level'+lev+'Translation'] ?? m['level'+lev]);
            return label;
          }
        }
      },
      docLabel(m) {
        let labelParts = [];
        for(let lev=1; lev<=5; lev++) {
          if(m['level'+lev]) {
            labelParts.push(m['level'+lev+'Translation'] ?? m['level'+lev]);
          }
        }
        let label = labelParts.join(' - ');
        return label;
      },
      selectedKey(m) {
        for(let i=5; i>=1; i--) {
          if(m['level'+i]) {
            return m['level'+i];
          }
        }
        return 'unknown';
      },
      loadNews() {
        this.websiteService.fetchIrinoxNews(this.$i18n.locale)
          .then((data) => {
            if(data?.data?.articles?.length>0) {
              let index = Math.floor(Math.random() * data.data.articles.length);
              this.news = data.data.articles[index];
            } else {
              this.news = null;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.news = null;
          });
      },
      geToWebsite(uri = null) {
        if(this.$config.currentEnv!='prod') {
          window.open('https://staging.fe.irinoxprofessional.we-dev.it/'+this.$functions.newsLanguages(this.$i18n.locale)+'/'+(uri??''), '_blank');
        } else {
          window.open('https://www.irinoxprofessional.com/'+this.$functions.newsLanguages(this.$i18n.locale)+'/'+(uri??''), '_blank');
        }
      }
    }
}
</script>

<style scoped>

.dashboard-news-image > div {
  aspect-ratio: 16 / 9;
  overflow: hidden;
  position: relative;
}
.dashboard-news-image > div > picture {
  width: 100%;
  height: 100%;
  position: relative;
}
.dashboard-news-image > div > picture > img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  transition: transform 1.2s cubic-bezier(0, -0.15, 0.15, 1.05);
}

.dashboard-news:hover .dashboard-news-image > div > picture > img {
  transform: scale(1.1);
  transition: transform 1.2s cubic-bezier(0, -0.15, 0.15, 1.05);
} 

</style>